import { Navigate, useLocation } from 'react-router-dom';
import PublicContainer from '../../components/containers/PublicContainer';
import { authAPI } from '../../services/redwolfSdkAPI';
import { getToken } from '../../utils/localStorage';
import { getSession, clearSession } from '../../utils/session';
import * as Sentry from '@sentry/react';
import { removeCookie } from '../../utils/cookies';

const PublicRoute = ({ children }: { children: JSX.Element }) => {
	const routerLocation: any = useLocation();
	const token = getToken();
	const verifyAccountToken = getSession('verifyAccountToken');

	if (token && !routerLocation.state?.isSocialLogin) {
		return <Navigate to="/" state={{ from: routerLocation }} replace />;
	}

	removeCookie('userProfile');

	if (verifyAccountToken) {
		authAPI
			.logout(verifyAccountToken)
			.then(() => {
				clearSession('verifyAccountToken');
			})
			.catch((err: any) => {
				Sentry.captureException(err);
			});
	}

	setTimeout(() => {
		const mainContainer = document.getElementById('main-container');

		if (mainContainer) {
			mainContainer.classList.add('accout-login');
		}
	}, 0);

	return <PublicContainer>{children}</PublicContainer>;
};

export default PublicRoute;
